import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { Modal } from "@website/ui/modal";
import { Sheet } from "@website/ui/sheet";
import { PurchaseCard } from "@website/widget/common/components/purchase-menu/components";
import { PurchaseMenuPropertiesType } from "@website/widget/common/components/purchase-menu/purchase-menu.types";
import { FC, memo } from "react";

const PurchaseMenu: FC<PurchaseMenuPropertiesType> = (properties) => {
  const { isOpen, onClose, list } = properties;

  const { isMobile, isTablet } = useViewPort();

  if (isMobile || isTablet) {
    return (
      <Modal
        className="!py-0"
        mobileHeight="auto"
        onClose={onClose}
        open={isOpen}
      >
        <div className="flex flex-col gap-2">
          <div className="flex h-16 items-center justify-between">
            <h6 className="text-on-surface-high-emphasis text-subtitle-1">
              انتخاب سرویس
            </h6>
            <button className="flex items-center justify-center">
              <MaterialIcon
                className="text-on-surface-high-emphasis text-2xl"
                name="close"
                onClick={onClose}
              />
            </button>
          </div>
          <p className="text-extra-caption text-on-surface-high-emphasis h-4">
            برای پیگیری سفارش، سرویس مورد نظر را انتخاب کنید.
          </p>
        </div>
        <PurchaseCard list={list} />
      </Modal>
    );
  }

  return (
    <Sheet
      onClose={onClose}
      open={isOpen}
      xGap="16px"
      xPosition="end"
      yPosition="end"
    >
      <div className="flex flex-col gap-2 px-4 py-2">
        <h6 className="text-subtitle-1 text-on-surface-high-emphasis h-6">
          انتخاب سرویس
        </h6>
        <p className="text-extra-caption text-on-surface-high-emphasis h-4">
          برای پیگیری سفارش، سرویس مورد نظر را انتخاب کنید.
        </p>
      </div>
      <PurchaseCard list={list} />
    </Sheet>
  );
};

const PurchaseMenuMemoized = memo(PurchaseMenu);
export { PurchaseMenuMemoized as PurchaseMenu };
